<template>
  <div>
    <el-dialog :width="Diawidth" :visible.sync="dialogVisible" :before-close="handleClose"
      :close-on-click-modal="true" :show-close="true" :close-on-press-escape="true">
      <span slot='title' class="el-dialog__title">淤地坝详情</span>
      <el-button class="tixing" type="warning" @click="tixingC" round>发送提醒</el-button>
      <el-input class="mhSearch" placeholder="请输入内容" v-model="input" clearable @input="searchInput"></el-input>
      <el-table :data="tableData" :row-class-name="rowIndex" stripe style="width: 100%;" height="600" empty-text="无数据"
        :default-sort="{prop: 'ydbName', order: 'descending'}" @row-dblclick="dbClick">
        <el-table-column :formatter="order" label="序号" width="60"></el-table-column>
        <el-table-column prop="ydbName" label="坝名" width="120"></el-table-column>
        <el-table-column prop="ydbSfwggb" label="类型" sortable width="80"></el-table-column>
        <el-table-column prop="ydbBaZhi" label="坝址" sortable width="300"></el-table-column>
        <el-table-column prop="ydbYxrs" label="下游影响人数" sortable width="140"></el-table-column>
        <el-table-column prop="ydbZyss" label="下游重要设施" width="190"></el-table-column>
        <el-table-column prop="ydbXzzrrlxfs" label="行政责任人联系方式" width="170"></el-table-column>
        <el-table-column prop="ydbJszrrlxfs" label="技术责任人联系方式" width="170"></el-table-column>
        <el-table-column prop="ydbXczrrlxfs" label="巡查责任人联系方式" width="170"></el-table-column>
        <el-table-column prop="ydbXjsxzzgbmzyfzrlxfs" label="主管部门负责人联系方式" width="200"></el-table-column>
        <el-table-column prop="ydbSfljb" label="是否老旧坝" width="100"></el-table-column>
      </el-table>

      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[15, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
  import {
    selectYdbInfoForYdbCodes,
    ydbjbxxsearch
  } from "@/api/api.js";
  export default {
    props: ["ClickName", "rainydbInfo"],
    data() {
      return {
        dialogVisible: true,
        Diawidth: "91%",
        currentPage: 1,
        pageSize: 15,
        tableData: [],
        totalNum: 0,
        input: ''
      }
    },
    mounted() {
      let params = {
        ydbCodes: this.rainydbInfo.toString(),
        pageNum: this.currentPage,
        pageSize: this.pageSize
      };
      this.selectYdbInfoForYdbCodesFun(params);
    },
    methods: {
      tixingC() {
        this.$message({
          message: '已通过app与短信发送提醒！',
          type: 'success'
        });
      },

      dbClick(row) {
        let params = {
          ydbCode: row.ydbCode
        };
        ydbjbxxsearch(params).then((res) => {
          this.$emit("queryDatas", res.data);
          this.$store.commit('queryData', res.data); //token
          this.cancel();
        });
      },

      selectYdbInfoForYdbCodesFun(params) {
        selectYdbInfoForYdbCodes(params).then((res) => {
          // console.log(res)
          this.totalNum = res.total;
          this.tableData = res.data;
        });
      },

      searchInput(value) {
        let params;
        if (value != '') {
          params = {
            ydbName: value,
            ydbCodes: this.rainydbInfo.toString(),
            pageNum: this.currentPage,
            pageSize: this.pageSize
          };
        } else {
          params = {
            ydbCodes: this.rainydbInfo.toString(),
            pageNum: this.currentPage,
            pageSize: this.pageSize
          };
        }
        this.selectYdbInfoForYdbCodesFun(params);
      },

      handleClose(done) {
        this.dialogVisible = false;
        this.$emit("cancel", {
          "dialogVisible": this.dialogVisible
        })
      },

      cancel() { //取消
        this.dialogVisible = false;
        this.$emit("cancel", {
          "dialogVisible": this.dialogVisible
        })
      },

      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageSize = val;
        let params;
        if (this.input != '') {
          params = {
            ydbName: this.input,
            ydbCodes: this.rainydbInfo.toString(),
            pageNum: this.currentPage,
            pageSize: this.pageSize
          };
        } else {
          params = {
            ydbCodes: this.rainydbInfo.toString(),
            pageNum: this.currentPage,
            pageSize: this.pageSize
          };
        }
        this.selectYdbInfoForYdbCodesFun(params);
      },

      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.currentPage = val;

        let params;
        if (this.input != '') {
          params = {
            ydbName: this.input,
            ydbCodes: this.rainydbInfo.toString(),
            pageNum: this.currentPage,
            pageSize: this.pageSize
          };
        } else {
          params = {
            ydbCodes: this.rainydbInfo.toString(),
            pageNum: this.currentPage,
            pageSize: this.pageSize
          };
        }
        this.selectYdbInfoForYdbCodesFun(params);
      },

      rowIndex({
        row,
        rowIndex
      }) {
        row.rowIndex = rowIndex;
      },

      order(row) {
        return this.pageSize * (this.currentPage - 1) + row.rowIndex + 1;
      }
    }
  }
</script>

<style scoped>
  >>>.el-dialog {
    height: 700px;
    background: url(../../common/images/dialog.png) no-repeat center;
    background-size: 100% 100%;
  }

  >>>.el-dialog__body {
    height: 610px;
    padding-top: 0;
  }

  >>>.el-dialog__header {
    /* border: none; */
    padding-left: 0;
    margin: 10px 20px 8px 20px;
  }
  
  >>>.el-dialog__body, .el-dialog__footer{
      background: transparent;
  }

  .mhSearch {
    position: absolute;
    top: 0;
    right: 80px;
    width: 200px;
    margin-top: 8px;
    /* transform: translate(-50%); */
  }

  .tixing {
    position: absolute;
    top: 9px;
    left: 7%;
    padding: 5px;
  }

  >>>.el-input__inner {
    height: 25px;
    line-height: 25px;
  }

  >>>.el-input__suffix {
    height: 25px;
    line-height: 25px;
  }

  >>>.el-input__icon {
    height: 25px;
    line-height: 25px;
  }

  >>>.el-table {
    margin-top: 10px;
    border-color: #0077AA;
    background-color: transparent !important;
  }

  >>>.el-table thead {
    background-color: rgba(0, 179, 254, 0.5) !important;
  }

  >>>.el-table .cell {
    text-align: center;
    font-size: 16px;
    color: #eaeaea;
  }

  >>>.el-table th {
    background-color: transparent !important;
    border-color: #0077AA;
  }

  >>>.el-table tr {
    background-color: transparent !important;
  }

  >>>.el-table td,
  >>>.el-table th.is-leaf {
    border-color: #0077AA;
  }

  >>>.el-table__body tr:hover>td {
    background-color: rgba(0, 179, 254, 0.3) !important;
  }

  >>>.el-table--border::after,
  >>>.el-table--group::after,
  >>>.el-table::before {
    background-color: #0077AA;
  }

  >>>.el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: rgba(0, 179, 254, 0.1);
  }

  >>>.el-pagination {
    margin-top: 4px;
    text-align: center;
    color: #fff;
  }

  >>>.el-pagination__total {
    color: #fff;
  }

  >>>.el-pagination__jump {
    color: #fff;
  }

  >>>.el-input__inner {
    background: transparent;
    color: #fff;
  }

  >>>.el-pager li {
    background: transparent;
    border: 0.5px solid #fff;
    padding: 0;
    margin: 0 4px;
  }

  >>>.el-pager li.btn-quicknext,
  .el-pager li.btn-quickprev {
    color: #fff;
  }

  >>>.el-pager .more::before {
    color: #fff;
  }

  >>>.el-pagination .btn-prev {
    background: transparent;
    color: #fff;
  }

  >>>.el-pagination .btn-next {
    background: transparent;
    color: #fff;
  }

  >>>.el-pager li.active+li {
    border-left: 1px solid #fff !important;
  }
</style>
